'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _forgottenPasswordConstants = require('./forgottenPasswordConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Initial state
// Lib
var initialState = Immutable.Map({
    resetSent: false,
    resetEmail: '',
    isError: false,
    error: null
});

// Constants

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _forgottenPasswordConstants.PASSWORD_RESET_REQUESTED:
            return state.set('resetSent', true).set('resetEmail', action.email);
        case _forgottenPasswordConstants.PASSWORD_RESET_REQUEST_FAILED:
            return state.set('isError', true).set('error', action.error);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/forgottenPassword/forgottenPasswordModalReducer.js
// module id = 1681
// module chunks = 0